import { Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { type SelectOption, SortPipe } from '@core';

@Component({
  host: {
    class: 'flex items-start flex-wrap gap-2',
  },
  imports: [MatIconModule, MatSelectModule, SortPipe],
  selector: 'avs-li-location-filters',
  standalone: true,
  templateUrl: './location-filters.component.html',
})
export class LocationFiltersComponent {
  inputConfig = input.required<{
    building?: boolean;
    floor?: boolean;

    options: {
      building: SelectOption[];
      floor: SelectOption[];
      room: SelectOption[];
    };
  }>({ alias: 'config' });

  filters = input<{
    building: string;
    floor: string;
    room: string;
  }>();

  filtersChanged = output<Record<string, string | undefined>>();

  protected config = computed(() => {
    const config = this.inputConfig();

    return {
      ...this.inputConfig(),
      building: config.building ?? true,
      floor: config.floor ?? true,
    };
  });
}
